import React from "react";
import { getShluchimTableColumns } from "../tripHelpers";

export default class ShluchimTableHeader extends React.PureComponent {
  render() {
    const {
      defaultChabadHouseCapacity,
      eventFeesPaid,
      hasVenues,
      isTravelTrip,
      selectAllDisabledReason,
      selectedShluchim,
      showSelectAllCheckbox,
      toggleSelectAllShluchim,
      totalShluchim,
    } = this.props;

    const columns = getShluchimTableColumns(
      isTravelTrip,
      defaultChabadHouseCapacity,
      eventFeesPaid,
      hasVenues,
    );
    const columnNames = columns.map((column) => column.name);
    const columnSizes = columns.map((column) => column.size).join(" ");

    return (
      <div
        className="trip-shluchim-table-header"
        style={{ gridTemplateColumns: columnSizes }}
      >
        {columnNames.map((column, index) => (
          <div className="flex flex-align-center" key={index}>
            {index === 0 && showSelectAllCheckbox && (
              <div className="tooltip-container mr-8">
                <div className="flex flex-align-center custom-checkbox-container mr-8">
                  <input
                    className="custom-checkbox"
                    checked={
                      selectedShluchim.all && !selectedShluchim.allExcept.length
                    }
                    disabled={!!selectAllDisabledReason || !totalShluchim}
                    id="all-shluchim"
                    onChange={toggleSelectAllShluchim}
                    type="checkbox"
                  />
                  <label className="flex-align-center" htmlFor="all-shluchim" />
                </div>
                {selectAllDisabledReason && (
                  <span className="tooltip">{selectAllDisabledReason}</span>
                )}
              </div>
            )}
            {column}
          </div>
        ))}
      </div>
    );
  }
}
